/* import __COLOCATED_TEMPLATE__ from './select.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { RECOVERY_REASONS, SUPPORT_NUMBER } from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/dormant-recover/base';
let EmberMultipassComponentsTwoFactorDormantRecoverSelectComponent = (_dec = service('ember-multipassfe-client'), _class = class EmberMultipassComponentsTwoFactorDormantRecoverSelectComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
  }
  get activationPhoneLabel() {
    return this.args.activationPhone?.description ?? '';
  }
  get activationPhoneEnabled() {
    return this.multipassfeClient.canUseActivationPhone;
  }
  get identityVerificationPhoneEnabled() {
    return this.multipassfeClient.canUseIdentityVerificationPhone;
  }
  get newPhoneEnabled() {
    return this.multipassfeClient.canUseNewPhone;
  }
  get heading() {
    if (this.args.allMethodsExhausted) {
      return this.intl.t(`${this.args.tPrefix}two_factor.dormant_recover.select.heading_exhausted`);
    }
    return this.intl.t(`${this.args.tPrefix}two_factor.dormant_recover.select.heading`);
  }
  get body() {
    if (this.args.recoveryReason === RECOVERY_REASONS.STEP_UP_AUTHENTICATION && this.args.allMethodsExhausted) {
      return this.intl.t(`${this.args.tPrefix}two_factor.dormant_recover.select.body_step_up`, {
        supportNumber: SUPPORT_NUMBER
      });
    }
    return '';
  }
  handleActivationPhoneClick() {
    if (this.activationPhoneEnabled) {
      this.args.navigateToActivationPhone();
    }
  }
  handleIdentityVerificationPhoneClick() {
    if (this.identityVerificationPhoneEnabled) {
      this.args.navigateToIdentityVerificationPhone();
    }
  }
  handleNewPhoneClick() {
    if (this.newPhoneEnabled) {
      this.args.navigateToNewPhone();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleActivationPhoneClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleActivationPhoneClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIdentityVerificationPhoneClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleIdentityVerificationPhoneClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleNewPhoneClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleNewPhoneClick"), _class.prototype), _class);
export { EmberMultipassComponentsTwoFactorDormantRecoverSelectComponent as default };